import { createFileRoute } from '@tanstack/react-router'
import { KeysPage } from '~/pages/org/keys-page'

export const Route = createFileRoute('/org/$org/keys')({
  component: OrgKeysPage,
})

function OrgKeysPage() {
  const { org } = Route.useParams()
  return <KeysPage organizationId={org} />
}
